var _style;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAbout(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "about_svg__Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 26 26",
    xmlSpace: "preserve"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null)), /*#__PURE__*/React.createElement("g", {
    id: "about_svg__Franz"
  }, /*#__PURE__*/React.createElement("g", {
    id: "about_svg__Group-Copy",
    transform: "translate(-293 -8)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "about_svg__menu-about",
    transform: "translate(294 8)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: props.fill,
    d: "M16.8 16.4l-8-8 4.8-4.8 8 8-4.8 4.8zm-6.3-8l6.3 6.3 3.1-3.1-6.3-6.3-3.1 3.1z",
    id: "about_svg__Stroke-1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "about_svg__Group-10",
    transform: "translate(0 .494)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: props.fill,
    d: "M17.7 17.8c-.4 0-.7-.1-.9-.4l-.7-.7c-.3-.3-.4-.6-.4-.9 0-.4.1-.7.4-.9l4.4-4.4c.5-.5 1.4-.5 1.9 0l.7.7c.5.5.5 1.4 0 1.9l-4.4 4.4c-.3.1-.6.3-1 .3zm3.8-6.6s-.1.1 0 0L17 15.7v.1l.8.8h.1l4.4-4.4c.1-.1.1-.1 0-.2l-.8-.8c.1.1 0 0 0 0z",
    id: "about_svg__Stroke-2"
  }), /*#__PURE__*/React.createElement("path", {
    fill: props.fill,
    d: "M21.7 23.2h-8.9c-.7 0-1.3-.6-1.3-1.3V21c0-.7.6-1.3 1.3-1.3h8.9c.7 0 1.3.6 1.3 1.3v.9c0 .7-.6 1.3-1.3 1.3zm-8.9-2.4c-.1 0-.1.1-.1.1v.9c0 .1.1.1.1.1h8.9c.1 0 .1-.1.1-.1v-.9c0-.1-.1-.1-.1-.1h-8.9z",
    id: "about_svg__Stroke-4"
  }), /*#__PURE__*/React.createElement("path", {
    fill: props.fill,
    d: "M8.9 8.9c-.4 0-.7-.1-.9-.3l-.7-.7c-.3-.3-.4-.6-.4-.9s.1-.7.4-1l4.4-4.4c.5-.5 1.4-.5 1.9 0l.7.7c.3.3.4.6.4.9 0 .4-.1.7-.4.9L9.8 8.6c-.2.2-.6.3-.9.3zm3.8-6.5c-.1 0-.1 0 0 0L8.1 6.9v.2l.7.7H9l4.5-4.5v-.1l-.8-.8z",
    id: "about_svg__Stroke-6"
  }), /*#__PURE__*/React.createElement("path", {
    fill: props.fill,
    d: "M2.7 23.8c-.4 0-.7-.1-.9-.4l-.7-.7c-.3-.3-.4-.6-.4-.9s.1-.7.4-.9L12.3 9.7l2.5 2.5L3.6 23.4c-.2.3-.6.4-.9.4zm9.6-12.4L1.9 21.7v.1l.8.8h.1l10.3-10.3-.8-.9z",
    id: "about_svg__Stroke-8"
  }))))));
}
export default SvgAbout;